import { render, staticRenderFns } from "./TablePageBudget.vue?vue&type=template&id=306c0d33"
import script from "./TablePageBudget.vue?vue&type=script&lang=js"
export * from "./TablePageBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports